import React from "react";
import { ReactComponent as BracketsIcon } from "../Icons/bracketsRaw.svg";
import { ReactComponent as BinaryIcon } from "../Icons/binaryRaw.svg";
import { ReactComponent as Formatter } from "../Icons/formatter.svg";
import { ReactComponent as Difference } from "../Icons/difference.svg";
import { ReactComponent as Converter } from "../Icons/converter.svg";
import { ReactComponent as Evaluator } from "../Icons/Evaluator.svg";
import { ReactComponent as URLIcon } from "../Icons/link.svg";
import { ReactComponent as HTMLIcon } from "../Icons/brackets-angle.svg";
import { ReactComponent as HashIcon } from "../Icons/hash.svg";
import { ReactComponent as FileIcon } from "../Icons/file-text.svg";
import {
  AlarmClock,
  Braces,
  CalendarClock,
  CalendarDays,
  CodeXml,
  Combine,
  DatabaseZap,
  Dice5,
  FileCode,
  FileDown,
  FileImage,
  FileInput,
  FileSpreadsheet,
  FileText,
  Files,
  FingerprintPattern,
  GitCompare,
  Hash,
  ImageUp,
  KeyRound,
  ListOrdered,
  Palette,
  PenTool,
  Regex,
  Replace,
  Scissors,
  ScrollText,
  ShieldCheck,
  Table,
  Timer,
  Type,
  Webhook,
} from "lucide-react";

const toolIcons = {
  "JSON Formatter": Formatter,
  "JSON Validator": BracketsIcon,
  "JSON Convertor": Converter,
  "JSON Converters": Converter,
  "JSON Difference": Difference,
  "JSON Diff": Difference,
  "JSON Evaluator": Evaluator,
  "JSON Structure Analyzer": Evaluator,
  "Base64 Encode/Decode": BinaryIcon,
  "Base64 Encoder/Decoder": BinaryIcon,
  "Base64 URL Encode/Decode": URLIcon,
  "Base64URL Encoder/Decoder": URLIcon,
  "URL Encode/Decode": URLIcon,
  "URL Encoder/Decoder": URLIcon,
  "HTML Encode/Decode": HTMLIcon,
  "HTML Encoder/Decoder": HTMLIcon,
  "HTML Entity Encoder/Decoder": HTMLIcon,
  "Hex Encode/Decode": HashIcon,
  "Hex Encoder/Decoder": HashIcon,
  "Quoted Printable Encode/Decode": FileIcon,
  "Quoted Printable": FileIcon,
  "Quoted-Printable Encoder/Decoder": FileIcon,
  "ASCII to Bytes Converter": BinaryIcon,
  "ASCII Bytes Converter": BinaryIcon,
  "Hash Generator": Hash,
  "HMAC Generator": KeyRound,
  "HMAC Calculator": KeyRound,
  "Argon2 Hash": FingerprintPattern,
  "Argon2 Hasher": FingerprintPattern,
  "JWT Encode/Decode": Braces,
  "JWT Decoder/Encoder": Braces,
  "BCrypt Hash": ShieldCheck,
  "Bcrypt Hash": ShieldCheck,
  "BCrypt Hasher": ShieldCheck,
  "Case Converter": Type,
  "Character count": ListOrdered,
  Counters: ListOrdered,
  "Word & Character Counter": ListOrdered,
  "Text Counter": ListOrdered,
  "Escape/Unescape": Braces,
  "Trim/Collapse": Scissors,
  "Whitespace Trim & Collapse": Scissors,
  "Whitespace Cleaner": Scissors,
  "LoremIpsum Generator": ScrollText,
  "Lorem Ipsum Generator": ScrollText,
  "UUID Generator": FingerprintPattern,
  "Random string Generator": Dice5,
  "Random String Generator": Dice5,
  "Color picker": Palette,
  "Color Picker": Palette,
  "Find and replace": Replace,
  "Find and Replace": Replace,
  "Find & Replace": Replace,
  "Regex tester": Regex,
  "Regex Pattern Tester": Regex,
  "Regex Tester": Regex,
  "Cron Parser": AlarmClock,
  "Cron Parser & Generator": AlarmClock,
  "Timezone Converter": CalendarClock,
  "Time Zone Converter": CalendarClock,
  "Time Difference Calculator": Timer,
  "Timestamp converter": CalendarDays,
  "Timestamp Converter": CalendarDays,
  "XML Formatter": CodeXml,
  "HTML Formatter": FileCode,
  "HTML Stripper": Scissors,
  "HTML Tag Remover": Scissors,
  "Markdown to HTML": FileText,
  "OpenAPI Architect": Webhook,
  "API Tool": Webhook,
  APILens: Webhook,
  "Text Diff": GitCompare,
  "CSV Diff": Table,
  "XML Diff": CodeXml,
  "JSON to SQL Converter": DatabaseZap,
  "JSON to SQL": DatabaseZap,
  "CSV to SQL Converter": FileSpreadsheet,
  "CSV to SQL converter": FileSpreadsheet,
  "CSV to SQL": FileSpreadsheet,
  "Image Tools": ImageUp,
  "Image Converter": ImageUp,
  "Base64 Image Tools": FileImage,
  "Base64 Image Converter": FileImage,
  "PDF & Image tools": Files,
  "PDF and Image Tools": Files,
  "PDF Image Converter": Files,
  "PDF merger and splitter": Combine,
  "PDF Merger & Splitter": Combine,
  Whiteboard: PenTool,
  "Flowchart & Mermaid Builder": PenTool,
  Flowlens: PenTool,
  FlowLens: PenTool,
  flowlens: PenTool,
  "Docx to PDF": FileDown,
  "Docx to PDF Converter": FileDown,
  "DOCX to PDF": FileDown,
  "Docx to Markdown": FileInput,
  "Docx to Markdown Converter": FileInput,
  "DOCX to Markdown": FileInput,
};

export function getToolIconComponent(toolName) {
  return toolIcons[toolName] || null;
}

export function renderToolIcon(toolName, className = "SubCategoryIcon") {
  const Icon = getToolIconComponent(toolName);
  return Icon ? React.createElement(Icon, { className }) : null;
}
